// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_CompanyProfessionListModel from '../../model/tdg-company-profession-list-model';
import Tdg_CompanyProfessionListDTO from '../dto/tdg-company-profession-list-dto';
import dtoSchema from '../schemas/tdg-company-profession-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import LocationModel from '../../model/location-model';

export default abstract class Tdg_CompanyProfessionListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_CompanyProfessionListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.externalId = data.externalId;
      this.companyName = data.companyName ?? undefined;
      this.companyId = data.companyId;
      this.profession = data.profession ?? undefined;
      this.category = data.category ?? undefined;
      this.organisationId = data.organisationId ?? undefined;
      this.organisationName = data.organisationName ?? undefined;
      this.logoDocumentId = data.logoDocumentId ?? undefined;
      this.description = data.description ?? undefined;
      this.website = data.website ?? undefined;
      this.employeesCount = data.employeesCount ?? undefined;
      this.apprenticesCount = data.apprenticesCount ?? undefined;
      this.apprenticeshipsCount = data.apprenticeshipsCount ?? undefined;
      this.companyContactSalutation = data.companyContactSalutation ?? undefined;
      this.companyContactFirstName = data.companyContactFirstName ?? undefined;
      this.companyContactLastName = data.companyContactLastName ?? undefined;
      this.companyContactPhoneNumber = data.companyContactPhoneNumber ?? undefined;
      this.companyContactEmail = data.companyContactEmail ?? undefined;
      this.companyStreet = data.companyStreet ?? undefined;
      this.companyHouseNumber = data.companyHouseNumber ?? undefined;
      this.companyZIP = data.companyZIP ?? undefined;
      this.companyCity = data.companyCity ?? undefined;
      this.companyLocation = data.companyLocation ? LocationModel.toModel(data.companyLocation) : undefined;
      this.acceptConditions = data.acceptConditions;
      this.eventId = data.eventId;
      this.eventName = data.eventName ?? undefined;
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {uuid}
  */
  externalId?: string;
  /**
  */
  companyName?: string;
  /**
  * @type {int64}
  */
  companyId?: number;
  /**
  */
  profession?: string;
  /**
  */
  category?: string;
  /**
  */
  organisationId?: string;
  /**
  */
  organisationName?: string;
  /**
  * @type {int64}
  */
  logoDocumentId?: number;
  /**
  */
  description?: string;
  /**
  */
  website?: string;
  /**
  * @type {int32}
  */
  employeesCount?: number;
  /**
  * @type {int32}
  */
  apprenticesCount?: number;
  /**
  * @type {int32}
  */
  apprenticeshipsCount?: number;
  /**
  * @type {int32}
  */
  companyContactSalutation?: number;
  /**
  */
  companyContactFirstName?: string;
  /**
  */
  companyContactLastName?: string;
  /**
  */
  companyContactPhoneNumber?: string;
  /**
  */
  companyContactEmail?: string;
  /**
  */
  companyStreet?: string;
  /**
  */
  companyHouseNumber?: string;
  /**
  */
  companyZIP?: string;
  /**
  */
  companyCity?: string;
  /**
  */
  companyLocation?: LocationModel;
  /**
  */
  acceptConditions?: boolean;
  /**
  * @type {int64}
  */
  eventId?: number;
  /**
  */
  eventName?: string;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<Tdg_CompanyProfessionListDTO>): Tdg_CompanyProfessionListModel;
  static toModel(dto: DeepPartial<Tdg_CompanyProfessionListDTO> | undefined | null): Tdg_CompanyProfessionListModel | undefined;
  static toModel(dto: DeepPartial<Tdg_CompanyProfessionListDTO> | undefined | null): Tdg_CompanyProfessionListModel | undefined {
    return dto ? new Tdg_CompanyProfessionListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_CompanyProfessionListModel> | Tdg_CompanyProfessionListModel): Tdg_CompanyProfessionListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      externalId: unwrapped.externalId,
      companyName: unwrapped.companyName,
      companyId: unwrapped.companyId,
      profession: unwrapped.profession,
      category: unwrapped.category,
      organisationId: unwrapped.organisationId,
      organisationName: unwrapped.organisationName,
      logoDocumentId: unwrapped.logoDocumentId,
      description: unwrapped.description,
      website: unwrapped.website,
      employeesCount: unwrapped.employeesCount,
      apprenticesCount: unwrapped.apprenticesCount,
      apprenticeshipsCount: unwrapped.apprenticeshipsCount,
      companyContactSalutation: unwrapped.companyContactSalutation,
      companyContactFirstName: unwrapped.companyContactFirstName,
      companyContactLastName: unwrapped.companyContactLastName,
      companyContactPhoneNumber: unwrapped.companyContactPhoneNumber,
      companyContactEmail: unwrapped.companyContactEmail,
      companyStreet: unwrapped.companyStreet,
      companyHouseNumber: unwrapped.companyHouseNumber,
      companyZIP: unwrapped.companyZIP,
      companyCity: unwrapped.companyCity,
      companyLocation: unwrapped.companyLocation,
      acceptConditions: unwrapped.acceptConditions,
      eventId: unwrapped.eventId,
      eventName: unwrapped.eventName,
      eventIdentifier: unwrapped.eventIdentifier,
    } as Tdg_CompanyProfessionListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_CompanyProfessionListModel, can not map to Tdg_CompanyProfessionListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
